import { PurchaseOrderLineItem } from '~/common/types';

export enum PurchaseOrderDetailsDataGridField {
  ID = 'id',
  POSITION = 'position',
  TITLE = 'title',
  DESCRIPTION = 'description',
  UNIT = 'unit',
  PRICE_PER_UNIT = 'pricePerUnit',
  QUANTITY = 'quantity',
  CURRENCY = 'currency',
}

export type PurchaseOrderDetailsDataGridRow = PurchaseOrderLineItem;
